import React from "react"
import PropTypes from "prop-types"
import Button from "../Button";

class QuoteGroupFilter extends React.Component {
  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-heading">
          Filter Groups
        </div>
        <div className="panel-body">
        </div>
      </div>
    )
  }
}

export default QuoteGroupFilter;